const ClassificationAlgorithmStatus = {
	NORMAL: 'Normal',
	PROBLEM: 'Problem'
};

export default ClassificationAlgorithmStatus;
